import { areUserRolesIn } from '../../../../../helpers';
import { Roles, ClinicalRelationships, BAYS } from '../../../../../constants';

import type {
  Bays,
  IClient,
  IOption,
  IProvider,
  IProviderAssignment,
  ITreatmentPlan,
} from '../../../../../utils/types';

export const getTpRouteSegment = (pathname: string): string => pathname.split('/')[3] ?? '';

export const getStatusBarBtProviderDisplayNames = (params: {
  userRoles: Roles[] | undefined;
  coAssignedProviders: IProvider[] | undefined;
  providerAssignments: IProviderAssignment[] | undefined;
}): string[] => {
  const { userRoles, coAssignedProviders, providerAssignments } = params;

  const names = areUserRolesIn(userRoles ?? [], [Roles.Bcba, Roles.Prbt, Roles.AssistantAssessor])
    ? coAssignedProviders?.map(
        (p: IProvider) => `${p?.first_name} ${p?.last_name ? p.last_name : ''}`,
      )
    : providerAssignments
        ?.filter(
          (pa: IProviderAssignment) => pa?.clinical_relationship === ClinicalRelationships.Prbt,
        )
        ?.map(
          (pa: IProviderAssignment) =>
            `${pa?.provider?.first_name} ${pa?.provider?.last_name ? pa.provider.last_name : ''}`,
        );

  return names ?? [];
};

export const getStatusBarBayChipLabel = (bay: Bays | null | undefined): string => {
  if (!bay) return '';

  const bayLabel = bay === BAYS.BAY_2_6 ? `${BAYS.BAY_2_6}/7` : bay;

  return `${bayLabel} TP`;
};

export function clientOptionFromPlan(
  treatmentPlan: ITreatmentPlan | null | undefined,
  clients: IClient[] | undefined,
): IOption | undefined {
  const client =
    clients?.find((item) => item.id === treatmentPlan?.client_id) ?? treatmentPlan?.client;
  if (!client || treatmentPlan?.client_id === undefined) return undefined;
  return {
    id: treatmentPlan.client_id,
    label: `${client.first_name} ${client.last_name}`,
  };
}
